/**
 * Head Scripts
 *
 * This module initializes scripts that need to run early in the page loading process.
 * It includes functionality for page redirects and language preferences.
 */

// Import modules
import { initPageRedirect } from './modules/page-redirect.js';

// Initialize modules immediately
initPageRedirect();

// Export functions for potential reuse
export {
    initPageRedirect,
};
